<template>
  <div id="EquipmentPoolTransfer">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Equipment Pool Transfer</div>
            <div class="web-action-btn btn-groups text-right">
                <!-- Button for Clear Cache -->
                <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'equipmentPoolTransfer'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
               <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'equipmentPoolTransfer'" :position="'top'">
                    </custom-pagination>

                    <vue-good-table
                        mode="remote"
                        ref="equipmentPoolTransfer"
                        title="equipmentPoolTransfer"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-select-all="onSelectAll"
                        @on-selected-rows-change="selectionChanged"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                        :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :search-options="{
                        enabled: false,
                        }"

                        >
                    </vue-good-table>
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                    </custom-pagination>
                </section>
               </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "EquipmentPoolTransfer",
  metaInfo(){
       return {
         title : 'Equipment Pool Transfer Report | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,

    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
       {
        label: "Unit Number",
        field: "unit_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit Number", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Unit Description",
        field: "unit_desc",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit Desc", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Ownership",
        field: "ownership",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit Ownership", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Assignment Date",
        field: "updated_at",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Assignment Time",
        field: "updated_time",
        filterable: true,
        fpFieldType:"text",
        sortable:false,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Assignment Time", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Pool From",
        field: "old_pool",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Pool From", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Pool From Desc",
        field: "old_pool_desc",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Pool From Desc", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Pool To",
        field: "new_pool",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Pool To", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Pool To Desc",
        field: "new_pool_desc",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Pool To Desc", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Equipment Type",
        field: "equip_type",
        fpFieldType:"option",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Equipment Type", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "User ID Create",
        field: "created_by",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "User Id Create", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Date Created",
        field: "created_at",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Time Created",
        field: "created_time",
        filterable: true,
        fpFieldType:"text",
        sortable:false,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Time Created", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Program Create",
        field: "program",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Program Create", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    action: '',
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'equipment_pool_transfer') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
      cancelAll: function (cancelAll) {
              this.$refs.equipmentPoolTransfer.unselectAllInternal();
            },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['equipmentPoolTransfer'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['equipmentPoolTransfer'].selectedRows[i].id)
      }

       var filterAll = self.serverParams.columnFilters;
        // if ( self.action == "export" ) {
        //     filterAll = self.removeOptionArr(self.serverParams.columnFilters);
        // }

      $.ajax({
        url: process.env.ROOT_API + "/equipment-pool-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });


    }
  }



}
</script>



// WEBPACK FOOTER //
// src/components/reports/EquipmentPoolTransfer.vue